import qs from "qs";
import Vue from "vue";
import { baseData } from "./js/regular";
import { bankRule, inputRule, moneyRule } from "./constant/exgRule.js";
import mixApi from "./mix-api";
import * as math from "mathjs";
import { mapActions, mapGetters } from "vuex";
import { isNumber } from "util";
import dayjs from "dayjs";
export let mixin = {
  mixins: [mixApi],
  data() {
    return {
      timerDebounce: null, //节流绑定的定时器
      middleObj: {},
      dayjs: dayjs,
      isBalance: {}, //报表是否平衡，  报表页面用到
      showItemMessage: false,
      showItemMessageNum: 0,
      loadingMin: true,
      loadingMinSec: true,
      initialIndex: 0,
      taskFresh: true,
      VATWords: {},
      loadStatus: true,
      baseData: baseData,
      messageNum: 0,
      AuthArr: [],
      flag: false,
      flagShow: true,
      // 分页
      pageTotal: 0,
      pageCommonZero: {
        currentPage: 0,
        pageSize: 20,
      },
      pageCommon: {
        pageNo: 1,
        pageSize: 20,
      },
      contactNum: "",
      accountNum: "",
      instanceNotify: "",
      ifLoading: false,
      userInfo: "",
      userCorp: {},
      justForPlateSelect: {}, //选择的税盘
      justForBookSelect: {},
      allForStatus: false,
      ifCoverShow: false,
      conditionShow: false,
      isShowTableCell: [],
      ifShowTableCell: [],
      timeout: null, //节流
      plateInfo: {}, //税盘信息
      customerStateOpts: [], //跟进状态
      signatureCustom: true,
      clientSourceArr: [], //客户来源
      isNewOrder: false, //false老订单，true新订单
      isShowTooltip: false, //文字是否溢出
    };
  },
  computed: {
    ...mapGetters("info", ["getSkinName"]), //获取皮肤
    // 是否是自己的账套，只在财税页面有使用justForBookSelect才有效
    isMineAccountBook() {
      if (this.justForBookSelect && this.justForBookSelect.isMy) {
        return true;
      }
      if (this.justForBookSelect && !this.justForBookSelect.isMy) {
        return false;
      }
      return true;
    },
    timeString() {
      if (!this.timeStringMonth) {
        return "";
      }

      var date = new Date(this.timeStringMonth);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var data = date.getDate();
      month = month < 10 ? "0" + month : month;
      var dateEnd = date;
      if (this.addShopping && this.addShopping.buyWay) {
        // 按月
        dateEnd.setMonth(date.getMonth() + this.num * 1 - 1);
      } else {
        // 按年
        dateEnd.setMonth(date.getMonth() + this.num * 12 - 1);
      }
      var yearEnd = dateEnd.getFullYear();
      var monthEnd = dateEnd.getMonth() + 1;
      monthEnd = monthEnd < 10 ? "0" + monthEnd : monthEnd;
      var dataEnd = dateEnd.getDate();
      var dateNow = `${year}年${month}月`;
      var dateEnd = `${yearEnd}年${monthEnd}月`;
      return dateNow + "-" + dateEnd;
    },
    buttonText() {
      return this.ifLoading ? "保存中" : "保存";
    },
  },
  methods: {
    //增值产品刷新
    ...mapActions("valueAdd", [
      "httpForCustomer",
      "httpForSpace",
      "httpForTax",
      "httpForBill",
      "httpForMeal",
      "httpForBook",
      "httpForText",
      "httpForUser",
      "httpForMall",
    ]),
    /*******
     * @description: 跳转到记账工具 新版
     * @return {*}params {
     * enterpriseId 公司id
     * accountBookId 账套id
     * contractStopTime 合同截止日期
     * }
     */
    async goTabsBrowser(
      module = "accountingCenter",
      params = {},
      path = "/accountIndex",
      config = {}
    ) {
      console.log(window.baseGate.accountUrl);
      let url = window.baseGate.accountUrl + path;
      if (process.env.NODE_ENV === "development") {
        url = "http://localhost:8090" + path;
      }
      config = JSON.stringify(config);
      let res = await this.getAccountBookToken(
        params.enterpriseId,
        params.accountBookId
      );
      if (res.data.code == 0) {
        url = `${url}?token=${
          res.data.data
        }&config=${config}&module=${module}&skin=${
          this.getSkinName || "绀青"
        }&source=22`;
        window.open(url, "_blank");
      }
    },

    findParent(vm) {
      if (!vm) {
        return;
      }
      if (vm.$vnode && vm.$vnode.parent) {
        return vm.$vnode;
      } else {
        return this.findParent(vm.$parent);
      }
    },
    toClearKeepAlive(val, router) {
      let router_ = router;
      if (this.$router) {
        router = router_;
      }
      if (router_) {
        router_.matcher.getRoutes().forEach((i) => {
          if (i.path === val) {
            this.clearKeepAlive(i.instances.default);
          }
        });
      }
    },
    // 清除keep-alive缓存
    clearKeepAlive(vm) {
      if (!vm) {
        return;
      }
      const vnode = this.findParent(vm);
      if (!vnode) return;
      const parentVnode = vnode.parent;
      if (parentVnode && parentVnode.componentInstance.cache) {
        const noKey = vnode.key == null;
        const key = noKey
          ? vnode.componentOptions.Ctor.cid +
            (vnode.componentOptions.tag
              ? `::${vnode.componentOptions.tag}`
              : "")
          : vnode.key;
        const cache = parentVnode.componentInstance.cache;
        const keys = parentVnode.componentInstance.keys;
        const cacheKeys = Object.keys(cache);
        const realKeys = noKey
          ? cacheKeys.filter((cacheKey) => cacheKey.startsWith(key))
          : [key];
        if (realKeys.length) {
          vm.$destroy();
          // remove key
          if (keys.length) {
            var index = keys.indexOf(key);
            if (index > -1) {
              keys.splice(index, 1);
            }
          }
          realKeys.forEach((realKey) => {
            cache[realKey] = null;
          });
        }
      }
    },
    /*******
     * @description: 获取账套的token
     * @param {*} enterpriseId 公司id
     * @param {*} accountBookId 账套id
     * @return {*}
     */
    getAccountBookToken(enterpriseId, accountBookId) {
      let params = {
        enterpriseId,
        accountBookId,
        businessCode: "KJSC",
      };
      return this.axios({
        method: "post",
        url: "/kjsc-merchant-service/yk/plat/enterprise/v1/get-account-token",
        data: params,
        interface: 1,
      });
    },
    /*******
     * @description: 跳转税表
     * @return {*}url
     */
    onOpenSBUrl(url, title) {
      url = encodeURIComponent(url);
      let windowUrl = window.baseGate.sjUrl + "?url=" + url + "&title=" + title;
      window.open(windowUrl);
    },
    /**
     * @description  财税那边要改为两种禁用
     * 建账到合同结束期之外和 有结账之前
     * @param {Object} getAccountYearVO
     * @returns {Object}  {Object} picker 能用的两种禁用  {String} 年月 默认显示日期
     */
    fomatterAccountYearVO(
      res = {
        accountYear: "2018-01",
        closeYear: "2018-02",
        allPeriodClose: false,
        serviceStart: 1509465600000,
        serviceEnd: 1614528000000,
      }
    ) {
      // disabledDate   结账？结账建账   到服务截止   必有
      // disabledDate2   建账之前   到服务截止 必有
      // disabledDate3    服务时间开始  到服务截止 必有
      // period  会计期默认显示日期
      let disabledDate, disabledDate2, disabledDate3;
      let defaultMonth = this.dayjs(res.accountYear).valueOf(); //默认建账时间

      disabledDate = (time) => {
        //建账之前 默认
        return (
          time.getTime() < this.dayjs(res.accountYear).valueOf() ||
          time.getTime() > new Date(res.serviceEnd).getTime()
        );
      };
      if (res.closeYear) {
        let closeMonth = this.dayjs(res.closeYear).add(1, "month").valueOf();
        //如果结账日期加一个月小于服务截止时间， 就取结账时间+一个月
        if (closeMonth < new Date(res.serviceEnd).getTime())
          defaultMonth = closeMonth;

        disabledDate = (time) => {
          return (
            time.getTime() < defaultMonth ||
            time.getTime() > new Date(res.serviceEnd).getTime()
          );
        };
      }

      disabledDate2 = (time) => {
        //建账之前 必有
        return (
          time.getTime() < this.dayjs(res.accountYear).valueOf() ||
          time.getTime() > new Date(res.serviceEnd).getTime()
        );
      };
      disabledDate3 = (time) => {
        //服务时间开始之前才有 必有
        return (
          time.getTime() < new Date(res.serviceStart).getTime() ||
          time.getTime() > new Date(res.serviceEnd).getTime()
        );
      };
      // console.log({defaultMonth: this.dayjs(defaultMonth).format('YYYY-MM'),
      //   accountYear: this.dayjs(res.accountYear).format('YYYY-MM'),
      //   serviceStart: this.dayjs(res.serviceStart).format('YYYY-MM')})
      return {
        period: this.dayjs(defaultMonth).format("YYYY-MM"),
        disabledDate,
        disabledDate2,
        disabledDate3,
      };
    },

    // 判断来源
    // value 21:PC-管理平台/22:PC-商户/24:PC-渠道
    // type 1：代提  2：系统/购买人
    checkPlatform(value, type, name = "") {
      let text = "";
      if (value == 21 || value == 24) {
        type == 1 ? (text = "代提") : (text = "系统");
      } else {
        type == 1 ? (text = "自提") : (text = name);
      }
      return text;
    },

    /**
     * @description  传入 想转化数字的 字符串
     * @param {String} likeNumber    {Number} num  最多保留的小数点位数
     * @returns Number}
     * eg: '-12ad123.3.4.41' =>  -12123.3
     */
    moneyTextFormatter(value = "0", num = 2) {
      let miusFont = (value + "").slice(0, 1) == "-" ? "-" : "";
      value = ("" + value).split("");
      //去掉非数字
      value = value.reduce((arr, it) => {
        if (/[0-9]|\./.test(it)) {
          arr.push(it);
        }
        return arr;
      }, []);

      let i = 0;
      let index = value.findIndex((it) => {
        if (it == ".") i++;
        if (it == "." && i == 2) return true;
        return false;
      });
      if (index > 0) {
        value = value.slice(0, index);
      }
      return miusFont + math.round(value.join(""), num);
    },
    /**
     * @description  不为平台 增值商品各个统计接口刷新方法
     * @param {String} name
     * @returns void
     */
    refreshValueAddProduct() {
      // 增值商品 this.userCorp.pkCorp != 'platform' 待联调 corp对象删除,直接取corpId
      if (JSON.parse(localStorage.getItem("corpId")) != "platform") {
        this.httpForSpace();
        this.httpForCustomer();
        this.httpForBill();
        this.httpForTax();
        this.httpForUser();
        this.httpForBook();
        this.httpForText();
        this.httpForMall();
      }
      this.httpForMeal();
      //end
    },
    /**
     * @description  dayjs 包装
     * @param {Date} date, str  eg: 'YYYY-MM-DD dddd HH:mm:ss.SSS A'
     * @returns {String} 返回指定格式
     */
    dayFormat(date, str) {
      if (!date) return;
      return dayjs(date).format(str);
      // YYYY-MM-DD dddd HH:mm:ss.SSS A
    },
    onlyMoney(rule, value, callback) {
      if (!/^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/.test(value)) {
        return callback(new Error("请输入正确金额"));
      }
      if (value == 0) {
        return callback(new Error("金额应大于0"));
      }
      callback();
    },
    getTextlength(str) {
      if (!str) return;
      return str.replace(/[\u0391-\uFFE5]/g, "a").length;
    },
    onlyNumEng(rule, value, callback) {
      if (!/^[0-9A-Za-z]*$/.test(value)) {
        return callback(new Error("请输入数字或是字母"));
      }
      callback();
    },
    changeSL(val) {
      //开票税率数子换英文
      val.fyxm.group.forEach((it) => {
        if (val.tspz == "10") {
          //特殊税率
          if (it.sl == 0.05) return (it.sl = "yqt");
          if (it.sl == 0.015) return (it.sl = "ja1.5");
        } else {
          //非特殊税率
          // if(it.yhzcbs==1){ //优惠政策标识为true 返回数据有点问题
          // }
          if (it.slbs == "1") return (it.sl = "ms");
          if (it.slbs == "2") return (it.sl = "bzs");
          return (it.sl = it.sl + ""); //最后普普通通
        }
      });
    },
    witchTaxTransform(num) {
      //开票税率英文换数子数字
      if (Number(num) + "" != "NaN") {
        return num / 100;
      }
      if (num == "ja1.5") return 0.015;
      if (num == "ms" || num == "bzs") return 0;
      if (num == "yqt") return 0.05;
    },
    getDay(num) {
      let str = "周";
      switch (num) {
        case 0:
          str += "日";
          break;
        case 1:
          str += "一";
          break;
        case 2:
          str += "二";
          break;
        case 3:
          str += "三";
          break;
        case 4:
          str += "四";
          break;
        case 5:
          str += "五";
          break;
        case 6:
          str += "六";
          break;
      }
      return str;
    },
    inputNumber(val) {
      return val.toString().replace(/[^\.\d-]/g, "");
    },
    replaceReg(str) {
      let reg = /\b(\w)|\s(\w)/g;
      str = str.toLowerCase();
      return str.replace(reg, function (m) {
        return m.toUpperCase();
      });
    },
    //节流
    throttle(func, wait = 1000) {
      let timeout;
      return function () {
        if (!timeout) {
          timeout = setTimeout(() => {
            func.apply(this, arguments);
            timeout = null;
          }, wait);
        }
      };
    },
    deepClone(obj) {
      let copy =
        Object.prototype.toString.call(obj).slice(8, -1) == "Array"
          ? []
          : !!obj
          ? {}
          : null;
      for (let i in obj) {
        if (obj.hasOwnProperty(i)) {
          copy[i] =
            typeof obj[i] === "object" ? this.deepClone(obj[i]) : obj[i];
        }
      }
      return copy;
    },
    ifDownload() {
      this.$confirm("是否确定下载客户端?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      }).then(() => {
        let url =
          "https://wkys-client.oss-cn-hangzhou.aliyuncs.com/%E7%8C%AA%E5%93%A5%E4%BA%91%E7%A5%A8%E6%8D%AE%E6%89%AB%E6%8F%8F%E5%AE%A2%E6%88%B7%E7%AB%AF.exe";
        let link = document.createElement("A");
        link.setAttribute("download", "");
        link.href = url;
        link.click();
      });
    },
    // 导出文件
    exportFile(blob, name) {
      let url = window.URL.createObjectURL(new Blob([blob]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
    // 导出文件
    exportFiles(res, name) {
      let url = window.URL.createObjectURL(res.data);
      let link = document.createElement("a");
      link.href = url;
      let fileName = res.headers["content-disposition"];
      try {
        fileName = fileName.split("filename=")[1];
        link.setAttribute("download", decodeURI(fileName) + "");
        link.click();
      } catch (e) {
        fileName = name;
        link.setAttribute("download", fileName);
        link.click();
      }
    },
    // 获取导出文件名
    getFileName(config) {
      let name = "";
      let strs = config["headers"]["content-disposition"] || "";
      if (strs && strs.indexOf("filename=") >= 0) {
        name = decodeURI(strs.split("filename=")[1]);
      }
      return name;
    },
    // url地址转文件
    transFile(name, cb) {
      this.changeBlob(name).then((res) => {
        var na = name.split("/");
        const files = new File([res], na[na.length - 1], {
          type: res.type,
        });
        cb(files);
      });
    },
    changeBlob(url) {
      return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "blob";
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response);
          }
        };
        xhr.send();
      });
    },
    downFile() {
      let link = document.createElement("A");
      link.setAttribute("download", "");
      link.href =
        Vue.axios.defaults.baseURL +
        "/file/fileProcessing/downloadFile?id=f93d7babe2caedcd243587fa9baac002&fileSource=ALIYUN&access_token=" +
        JSON.parse(Vue.axios.defaults.token);
      link.click();
    },
    urlGet(id) {
      if (!id) return;
      return this.$upload.downLoadImgUrl + id;
    },
    initUserRole() {
      this.axios({
        method: "GET",
        url: "/service-user-app/app/organization/structure/query/user-type?type=4",
      }).then((res) => {
        let data = res.data;
        if (data.code == "0") {
          // 1 管理员 2 部门主管 3 普通员工
          let role = Number(data.data) - 1;
          this.userRole = role;
          this.$set(this.userInfo, "userRole", data.data);
          let detail = JSON.parse(window.LS.get("SY"));
          detail.userInfo = this.userInfo;
          window.LS.set("SY", JSON.stringify(detail));
        } else {
          this.MixsuccessMes(data.message);
        }
      });
    },
    fileTypeShow(name) {
      var ext = null;
      var i = name.lastIndexOf(".");
      if (i > -1) {
        var ext = name.substring(i);
      }
      return ext;
    },
    onlyFileTypeShow(name) {
      var ext = null;
      var i = name.lastIndexOf(".");
      if (i > -1) {
        var ext = name.substring(i + 1);
      }
      return ext;
    },
    ZHCurrency(money = 0) {
      let ZH = money < 0 ? "负" : "";
      money = Math.abs(money);
      money = new Number(new Number(money).toFixed(2)).valueOf();
      //汉字的数字
      var cnNums = new Array(
        "零",
        "壹",
        "贰",
        "叁",
        "肆",
        "伍",
        "陆",
        "柒",
        "捌",
        "玖"
      );
      //基本单位
      var cnIntRadice = new Array("", "拾", "佰", "仟");
      //对应整数部分扩展单位
      var cnIntUnits = new Array("", "万", "亿", "兆");
      //对应小数部分单位
      var cnDecUnits = new Array("角", "分", "毫", "厘");
      //整数金额时后面跟的字符
      var cnInteger = "整";
      //整型完以后的单位
      var cnIntLast = "元";
      //最大处理的数字
      var maxNum = 999999999999999.9999;
      //金额整数部分
      var integerNum;
      //金额小数部分
      var decimalNum;
      //输出的中文金额字符串
      var chineseStr = "";
      //分离金额后用的数组，预定义
      var parts;
      if (money === "") {
        return "";
      }
      money = parseFloat(money);
      if (money >= maxNum) {
        //超出最大处理数字
        return "";
      }
      if (money == 0) {
        chineseStr = cnNums[0] + cnIntLast + cnInteger;
        return chineseStr;
      }
      //转换为字符串
      money = money.toString();
      if (money.indexOf(".") == -1) {
        integerNum = money;
        decimalNum = "";
      } else {
        parts = money.split(".");
        integerNum = parts[0];
        decimalNum = parts[1].substr(0, 4);
      }
      //获取整型部分转换
      if (parseInt(integerNum, 10) > 0) {
        var zeroCount = 0;
        var IntLen = integerNum.length;
        for (var i = 0; i < IntLen; i++) {
          var n = integerNum.substr(i, 1);
          var p = IntLen - i - 1;
          var q = p / 4;
          var m = p % 4;
          if (n == "0") {
            zeroCount++;
          } else {
            if (zeroCount > 0) {
              chineseStr += cnNums[0];
            }
            //归零
            zeroCount = 0;
            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
          }
          if (m == 0 && zeroCount < 4) {
            chineseStr += cnIntUnits[q];
          }
        }
        chineseStr += cnIntLast;
      }
      //小数部分
      if (decimalNum != "") {
        var decLen = decimalNum.length;
        for (var i = 0; i < decLen; i++) {
          var n = decimalNum.substr(i, 1);
          if (n != "0") {
            chineseStr += cnNums[Number(n)] + cnDecUnits[i];
          }
        }
      }
      if (chineseStr == "") {
        chineseStr += cnNums[0] + cnIntLast + cnInteger;
      } else if (decimalNum == "") {
        chineseStr += cnInteger;
      }
      return ZH + chineseStr;
    },
    // 监听滚动，固定表头
    scrollFixed(target, wrap) {
      let $target = document.querySelector(target);
      let $wrap = document.querySelector(wrap);
      let $mainInfoH = document.querySelector(".mainInfo");
      window.addEventListener(
        "scroll",
        () => {
          var targetH =
            Math.round($wrap.getBoundingClientRect().top) -
            Math.round($mainInfoH.getBoundingClientRect().top);
          let parentW = window.getComputedStyle($wrap).width;
          let domH = window.getComputedStyle($target).height;
          if (targetH <= 0) {
            $target.classList.add("fixedHeader");
            $target.style.width = parentW;
            $target.style.top = "108px";
            $wrap.style.paddingTop = domH;
          } else {
            $wrap.style.paddingTop = "0px";
            if ($target.classList.contains("fixedHeader")) {
              $target.classList.remove("fixedHeader");
            }
          }
        },
        true
      );
    },
    deleteFile(id) {
      this.axios({
        method: "DELETE",
        url: "/file/fileProcessing/" + id,
      }).then(function (res) {});
    },
    updateRouter() {
      this.$router.push({
        path: "/company/detail",
      });
    },
    changeTab(str) {
      this.$router.push({
        path: str,
      });
    },
    rowClassSecTask({ row, rowIndex }) {
      var ifUrgent = row.taskitemOrderInfos.find((item) => {
        return item.taskItems.find((items) => {
          return (
            this.timeDuringH(items.endModifyTime) &&
            items.status != 4 &&
            items.status != 5
          );
        });
      });
      return ifUrgent ? "urgent" : "";
    },
    timeDuringH(date) {
      if (!date) return false;
      return (
        Math.ceil(
          (new Date().getTime() - new Date(date).getTime()) /
            (24 * 60 * 60 * 1000)
        ) > 3
      );
    },
    rowClassSec({ row, rowIndex }) {
      var ifUrgent = row.taskitemOrderInfos.find((item) => {
        return item.taskItems.find((items) => {
          return items.urgent && items.status != 4 && items.status != 5;
        });
      });
      var ifDay = row.taskitemOrderInfos.find((item) => {
        return item.taskItems.find((items) => {
          return (
            this.timeDuringH(items.endModifyTime) &&
            items.status != 4 &&
            items.status != 5
          );
        });
      });
      if (ifDay && ifUrgent) {
        return "allError";
      }
      if (ifDay && !ifUrgent) {
        return "onlyDayError";
      }
      if (!ifDay && ifUrgent) {
        return "onlyUrgentError";
      }
    },
    // 新接口根据id查询个人信息
    seeDetailId(id) {
      console.log("操作人是否进入");
      if (id == "-1") return;
      return new Promise((reslove, reject) => {
        this.axios({
          method: "get",
          url: `/service-user-app/app/user/current/user/detail?id=${id}`,
          interface: 1,
        }).then((res) => {
          console.log("res++", res);
          if (res.data.code == 0) {
            this.dig.perData = res.data.data;
            this.dig.perInfo = true;
            reslove(res.data.data);
          }
        });
      });
    },
    // 查看个人信息 根据pkUser
    seeDetail(a) {
      if (a == "无") return;
      this.pckUser = a;
      let pckUser = this.pckUser;
      this.axios({
        method: "POST",
        url: "/platform/feedback/userDetailsByPk",
        params: {
          pkUser: pckUser,
        },
      }).then((res) => {
        let data = res.data;
        if (data.code === "0") {
          let role = [];
          let dept = [];
          dept = data.data.dept;
          role = data.data.role;

          this.$set(this.perData, "name", data.data.userName);
          this.$set(this.perData, "phone", data.data.phone);
          this.$set(this.perData, "headImg", data.data.img.avatar);
          this.$set(this.perData, "dept", dept);
          this.$set(this.perData, "role", role);
          this.dialogVisible = true;
        } else {
          this.MixerrorMes(data.message);
        }
      });
    },
    // 查看个人信息 根据id
    seeDetail1(id) {
      this.axios({
        method: "get",
        url: "/callCenter/feedback/userDetailsByUserId?userId=" + id,
      }).then((res) => {
        let data = res.data;
        if (data.code === "0") {
          let role = [];
          let dept = [];
          dept = data.data.dept;
          role = data.data.role;
          this.$set(this.perData, "name", data.data.userName);
          this.$set(this.perData, "phone", data.data.phone);
          this.$set(this.perData, "headImg", data.data.img.avatar);
          this.$set(this.perData, "dept", dept);
          this.$set(this.perData, "role", role);
          this.dialogVisible = true;
        } else {
          this.MixerrorMes(data.message);
        }
      });
    },
    //查询当前公司是否设置了短信签名
    signature(str) {
      console.log(str);
      this.axios
        .get("/service-sms-app/app/corp-signature/record")
        .then((res) => {
          let data = res.data;
          if (data.code == "0") {
            // true 能修改  false 不能
            if (data.data) {
              this.signatureCustom = data.data.custom;
              if (str == "sz") {
                this.ruleForm = data.data;
              }
              if (str == "hx") {
                this.ruleForm.sign = data.data.sign;
              }
            }
          }
        });
    },
    // 跟进状态&签单评估
    onState() {
      this.axios
        .get("/service-platform-app/app/merchant-app-follow-up-status/get-all")
        .then((res) => {
          if (res.data.code == 0) {
            this.customerStateOpts = res.data.data;
          }
        });
    },
    // 客户来源
    clientSourceHttp() {
      this.axios
        .get("/service-customer-app/app/customer-config/list?type=2", {
          interface: 1,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.clientSourceArr = res.data.data;
            if (res.data.data.length != 0) this.soureceId = res.data.data[0].id;
          }
        });
    },
    // 树结构数据处理
    formatData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].childList) {
          if (data[i].childList.length < 1) {
            data[i].childList = null;
          } else {
            this.formatData(data[i].childList);
          }
        }
      }
      return data;
    },
    //判断是否是新老订单（true 新）
    isNewOrderHttp() {
      // let info = JSON.parse(window.LS.get("SY") || '{}') corp对象已经删除,直接取corpId
      // let corpId = info && info.corp && info.corp.id
      let corpId = JSON.parse(localStorage.getItem("corpId"));
      this.axios({
        url: "/service-user-app/app/merchant-new-mall/corp-id",
        params: {
          corpId: corpId,
        },
        interface: 1,
      }).then((res) => {
        if (res.data.code == 0) {
          this.isNewOrder = res.data.data;
        }
      });
    },
    // 文字匹配
    publicValueText(arr, value) {
      var a = arr.find((item) => {
        return item.value == value;
      });
      return a ? a.label : "";
    },
    // 客户来源匹配文字
    clientSourceText(arr, value) {
      var a = arr.find((item) => {
        return item.id == value;
      });
      return a ? a.label : "";
    },
    // 超出内容显示省略号显示el-tooltip
    visibilityTooltip(event) {
      const ev = event.target;
      const ev_weight = ev.scrollWidth; // 文本的实际宽度   scrollWidth：对象的实际内容的宽度，不包边线宽度，会随对象中内容超过可视区后而变大。
      const content_weight = ev.clientWidth; // 文本的可视宽度 clientWidth：对象内容的可视区的宽度，不包滚动条等边线，会随对象显示大小的变化而改变。
      // const content_weight = this.$refs.tlp.$el.parentNode.clientWidth; // 文本容器宽度(父节点)
      if (ev_weight > content_weight) {
        // 实际宽度 > 可视宽度  文字溢出
        this.isShowTooltip = true;
      } else {
        // 否则为不溢出
        this.isShowTooltip = false;
      }
    },
    // 通用匹配文字
    generalText(arr, val) {
      var a = arr.find((item) => {
        return item.value == val;
      });
      return a ? a.label : "";
    },
    // 页面有无权限
    goUrl(url) {
      this.axios({
        method: "post",
        url: "/platform/checkUserRolePortal",
        data: {
          url: url,
        },
        transformRequest: [
          function (data) {
            return qs.stringify(data);
          },
        ],
      }).then((res) => {
        let data = res.data;
        if (data.code == "0") {
          this.$router.push({
            path: url,
          });
        } else {
          this.$message({
            message: data.message,
            type: "warning",
          });
        }
      });
    },
    // 5.4 短信发送失败重新发送
    resend(id) {
      this.axios({
        url: `/service-sms-app/app/send-message/again-send-message?id=${id}`,
        method: "get",
        interface: 1,
      }).then((res) => {
        if (res.data.code == 0) {
          this.MixsuccessMes("发送成功");
          this.httpInit();
        }
      });
    },
    saveShowTool(url) {
      var arr = this.ifShowTableCell.filter((item) => {
        return this.isShowTableCell.indexOf(item.value) > -1;
      });
      this.axios({
        method: "post",
        url: `/service-platform-app/app/commSelector/save/${
          url ? url : this.$route.path.slice(1)
        }`,
        data: arr,
      }).then((res) => {
        let data = res.data;
        if (data.code == "1") {
        } else {
          this.MixerrorMes(data.message);
        }
      });
    },
    // 5.4 操作手册跳转
    onTargetOperation(url) {
      this.axios({
        url: "/service-system-app/app/operation-manual-url-map/select-operation-manual-url-map-by-url",
        method: "GET",
        interface: 1,
        params: {
          url: url,
        },
      })
        .then((res) => {
          if (res.data.code == 0) {
            let id = res.data.data.urlMap;
            if (id) {
              let routeUrl = this.$router.resolve({
                path: `/operationManualView?url=${url}`,
              });
              window.open(routeUrl.href, "_blank");
            } else {
              this.MixerrorMes(res.data.message);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getshowTool(call, url) {
      this.axios({
        method: "post",
        // url: "/callCenter/commSelector/find", 接口切换待联调
        url: "/service-platform-app/app/commSelector/find",

        data: {
          pageUrl: url ? url : this.$route.path.slice(1),
        },
      }).then((res) => {
        let data = res.data;
        if (data.code == "1") {
          call ? call() : "";
          this.isShowTableCell = data.data.arr;
          this.ifShowTableCell = data.data.selectorSetList;
        }
      });
    },
    backText(arr, value) {
      var a = "";
      arr.forEach(function (item) {
        item.value == value ? (a = item.text) : "";
      });
      return a;
    },
    //返回匹配指定pk名的pk的 数组中某项的 指定属性值
    backTextCommon(arr, pkProps, value, textProps) {
      var a = "";
      arr.forEach(function (item) {
        item[pkProps] == value ? (a = item[textProps]) : "";
      });
      return a;
    },
    showMore() {
      this.conditionShow = !this.conditionShow;
    },
    monthDayDiff(startDate, endDate, currentMonthl, total, now, name, pk) {
      let currentMonth = currentMonthl
        ? currentMonthl
        : `${new Date().getFullYear() + 1000}年01月`;

      let flag = [1, 3, 5, 7, 8, 10, 12, 4, 6, 9, 11, 2];
      let start = new Date(startDate);
      let end = new Date(endDate);
      let year = end.getFullYear() - start.getFullYear();
      let month = end.getMonth() - start.getMonth();
      let day = end.getDate() - start.getDate();
      if (month < 0) {
        year--;
        month = end.getMonth() + (12 - start.getMonth());
      }
      if (day < 0) {
        month--;
        let index = flag.findIndex((temp) => {
          return temp === start.getMonth() + 1;
        });
        let monthLength;
        if (index <= 6) {
          monthLength = 31;
        } else if (index > 6 && index <= 10) {
          monthLength = 30;
        } else {
          monthLength = 28;
        }
        day = end.getDate() + (monthLength - start.getDate());
      }
      var arrObj = {
          arrTime: [],
        },
        _self = this;
      // 循环 12 * year + month+1次数
      for (var i = 0; i < 12 * year + month + 1; i++) {
        _self.fmtMouth(new Date(currentMonth.replace(/[^\d]/g, "-"))) ==
        _self.fmtMouth(startDate)
          ? (arrObj.current = i)
          : "";
        arrObj.arrTime.push({
          date: _self.fmtMouth(startDate),
          total: total,
          name: name,
          pk: pk,
          now:
            _self.fmtMouth(new Date(currentMonth.replace(/[^\d]/g, "-"))) ==
            _self.fmtMouth(startDate)
              ? now
              : "none",
        });
        if (new Date(currentMonth.replace(/[^\d]/g, "-")) > endDate) {
          arrObj.current = 1000000000000000000;
        }
        startDate.setMonth(startDate.getMonth() + 1);
      }
      return arrObj;
    },
    allForMore() {
      this.allForStatus = !this.allForStatus;
    },
    limitStrLength(str, num) {
      if (!str) return;
      return str.length > num ? str.slice(0, num) + "..." : str;
    },
    exgBank(val, el) {
      bankRule(val, el.target, this.MixWarnMes);
    },
    exgInput(val, el) {
      inputRule(val, el.target, this.MixWarnMes);
    },
    exgMoney(val, el) {
      moneyRule(val, el.target, this.MixWarnMes);
    },
    scropToTop() {
      var currentEl = document.querySelector(
        ".right-content .el-scrollbar__wrap"
      );
      var currentScroll = currentEl.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(this.scropToTop);
        currentEl.scrollTo(0, currentScroll - currentScroll / 5);
      }
    },
    timeCycle(time) {
      if (!time) return;
      let now = new Date(time);
      let year = now.getFullYear(); //得到年份
      let month = now.getMonth(); //得到月份
      let date = now.getDate(); //得到日期
      let hour = now.getHours(); //得到小时
      let minu = now.getMinutes(); //得到分钟
      let sec = now.getSeconds(); //得到秒
      return `${year}-${month + 1 < 10 ? "0" + (month + 1) : month + 1}-${
        date < 10 ? "0" + date : date
      } ${hour < 10 ? "0" + hour : hour}:${minu < 10 ? "0" + minu : minu}:${
        sec < 10 ? "0" + sec : sec
      }`;
    },
    findObjText(arr, text, dataText, data) {
      var a = arr.find((item) => {
        return item[dataText] == data;
      });
      if (a) {
        return a[text];
      }
    },
    ifShowDetail(arr, hasArr) {
      return !!arr.find(function (item) {
        return hasArr.indexOf(item.pkCustomerLicense) > -1;
      });
    },
    chooseFrist(arr, hasArr) {
      var arrCopy = JSON.parse(JSON.stringify(arr));
      var aleardyArr = JSON.parse(JSON.stringify(hasArr));
      // 已有的是否存在
      arrCopy.forEach(function (item, index) {
        var status = item.detail.find(function (itemS, indexS) {
          return aleardyArr.indexOf(itemS.pkCustomerLicense) > -1;
        });
        if (status) {
          item.detail.forEach(function (itemS, indexS) {
            if (aleardyArr.indexOf(itemS.pkCustomerLicense) > -1) {
              item.detail.unshift(item.detail.splice(indexS, 1)[0]);
            }
          });
          arrCopy.unshift(arrCopy.splice(index, 1)[0]);
        }
      });
      return arrCopy;
    },
    changeLocation(arr) {
      arr.forEach(function (item, index) {
        var status = item.detail.find(function (itemS, indexS) {
          return !!itemS.checked;
        });
        if (status) {
          item.detail.forEach(function (itemS, indexS) {
            if (itemS.checked) {
              item.detail.unshift(item.detail.splice(indexS, 1)[0]);
            }
          });
          arr.unshift(arr.splice(index, 1)[0]);
        }
      });
      return arr;
    },
    // 显示更多
    isShowMore(arr, item, index) {
      this.$set(this.optList[index].detail, "str", !item.str);
    },
    isShowMore_1(arr, item, index) {
      this.$set(arr[index].detail, "str", !item.str);
    },
    isShowMoreData() {},
    anti_formatArr(arr, key) {
      var newArr = [];
      arr.forEach(function (item, index, arr) {
        newArr.push(item[key]);
      });
      return newArr;
    },
    openConfirm(row, callback) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          callback(row);
        })
        .catch(() => {});
    },
    /**
     * @Description:  obj 空验证
     * @retrun
     */
    isEmpty(obj) {
      return typeof obj == "undefined" || obj == null || obj == "";
    },
    // 判断时间为今天
    judgeTime(data) {
      var date = data.toString();
      var year = date.substring(0, 4);
      var month = date.substring(4, 6);
      var day = date.substring(6, 8);
      var d1 = new Date(year + "/" + month + "/" + day);
      var dd = new Date();
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1;
      var d = dd.getDate();
      var d2 = new Date(y + "/" + m + "/" + d);
      var iday = parseInt(d2 - d1) / 1000 / 60 / 60 / 24;
      return iday;
    },
    // todo 新加的
    timeFor(timestamp) {
      var Y, M, D, h, m, s;
      var date = new Date(timestamp);
      Y = date.getFullYear() + "-";
      M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      D = date.getDate() + " ";
      h = date.getHours() + ":";
      m = date.getMinutes() + ":";
      s = date.getSeconds();
      return Y + M + D + h + m + s;
    },
    fmtMouth(date, num) {
      if (num) {
        date.setMonth(date.getMonth() + num);
      }
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      return y + "-" + m;
    },
    fmtHour(obj, str, noM) {
      var date;
      var reg = /^[0-9]+.?[0-9]*$/;
      if (reg.test(obj)) {
        date = new Date(parseFloat(obj));
      } else {
        date = new Date(obj);
      }
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      return h + ":" + minute;
    },
    formatUTC(utc_datetime) {
      if (!utc_datetime) return;
      // 转为正常的时间格式 年-月-日 时:分:秒
      if (isNumber(utc_datetime)) return utc_datetime;
      var T_pos = utc_datetime.indexOf("T");
      // var Z_pos = utc_datetime.indexOf(".000+0000");
      var Z_pos = utc_datetime.length - length - 9;
      var year_month_day = utc_datetime.substr(0, T_pos);
      var hour_minute_second = utc_datetime.substr(
        T_pos + 1,
        Z_pos - T_pos - 1
      );

      var new_datetime = year_month_day + " " + hour_minute_second; // 2017-03-31 08:02:06
      new_datetime = new_datetime.replace(/-/g, "/");
      // 处理成为时间戳
      timestamp = new Date(Date.parse(new_datetime));
      timestamp = timestamp.getTime();
      timestamp = timestamp / 1000;

      // 增加8个小时，北京时间比utc时间多八个时区
      var timestamp = timestamp + 8 * 60 * 60;
      // 时间戳转为时间
      var beijing_datetime = new Date(parseInt(timestamp) * 1000);
      return parseInt(timestamp) * 1000;
    },

    fmtDate(obj, str, noM) {
      /**
       * @author liu
       * @date 2019/7/10/010
       * @Description:  obj type 1 时间戳，2 国际时间字符串，3 date对象，4 非标准串2019-20-11...
       * @retrun
       */
      if (!obj) return;
      var date;
      var reg = /^[0-9]+.?[0-9]*$/;
      if (reg.test(obj)) {
        date = new Date(parseFloat(obj));
      } else if (obj instanceof Object) {
        date = new Date(obj);
      } else {
        if (obj.includes("T")) {
          date = new Date(this.formatUTC(obj));
        } else {
          date = new Date(obj.replace(/-/g, "/"));
        }
      }
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      if (str) {
        return noM ? y + "-" + m : y + "-" + m + "-" + d;
      } else {
        return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
      }
    },
    //显示例如2019.20.11
    fmtDate1(obj, str, noM) {
      /**
       * @author liu
       * @date 2019/7/10/010
       * @Description:  obj type 1 时间戳，2 国际时间字符串，3 date对象，4 非标准串2019.20.11...
       * @retrun
       */
      if (!obj) return;
      var date;
      var reg = /^[0-9]+.?[0-9]*$/;
      if (reg.test(obj)) {
        date = new Date(parseFloat(obj));
      } else if (obj instanceof Object) {
        date = new Date(obj);
      } else {
        if (obj.includes("T")) {
          date = new Date(this.formatUTC(obj));
        } else {
          date = new Date(obj.replace(/./g, "/"));
        }
      }
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      if (str) {
        return noM ? y + "." + m : y + "." + m + "." + d;
      } else {
        return y + "." + m + "." + d + " " + h + ":" + minute + ":" + second;
      }
    },
    // 阿拉伯数字–>中文汉字
    SectionToChinese(section) {
      var chnNumChar = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ];
      var chnUnitSection = ["", "万", "亿", "万亿", "亿亿"];
      var chnUnitChar = ["", "十", "百", "千"];
      var strIns = "",
        chnStr = "";
      var unitPos = 0;
      var zero = true;
      while (section > 0) {
        var v = section % 10;
        if (v === 0) {
          if (!zero) {
            zero = true;
            chnStr = chnNumChar[v] + chnStr;
          }
        } else {
          zero = false;
          strIns = chnNumChar[v];
          strIns += chnUnitChar[unitPos];
          chnStr = strIns + chnStr;
        }
        unitPos++;
        section = Math.floor(section / 10);
      }
      return chnStr;
    },

    hoursFormat(time) {
      var time = time / 1000;
      var timeS = null;
      var day = 0,
        hour = 0,
        minute = 0,
        second = 0;
      if (time > 0) {
        day = Math.floor(time / (60 * 60 * 24));
        hour = Math.floor(time / (60 * 60)) - day * 24;
        minute = Math.floor(time / 60) - day * 24 * 60 - hour * 60;
        second =
          Math.floor(time) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60;
      }
      if (day <= 9) day = "0" + day;
      if (hour <= 9) hour = "0" + hour;
      if (minute <= 9) minute = "0" + minute;
      if (second <= 9) second = "0" + second;
      return `${hour} : ${minute} : ${second}`;
    },
    // 任务分发  列表
    taskFormat(data) {
      let arr = [];
      Object.keys(data).forEach(function (key, i, v) {
        var obj = {};
        obj.name = key;
        obj.checked = false;
        obj.order = [];
        // arr.push(obj)
        Object.keys(data[key]).forEach(function (keys) {
          var obj_s = {
            orderNum: keys,
          };
          obj_s.items = data[key][keys];
          obj_s.pkOrderInfo = data[key][keys][0].pkOrderInfo;
          obj_s.items.forEach(function (items) {
            items.checked = false;
          });
          obj.order.push(obj_s);
        });
        arr.push(obj);
      });
      console.log("arr", arr);
      return arr;
    },
    // 数组对象key-value配对
    listFormat(data, str) {
      let arr = [];
      Object.keys(data).forEach(function (key, i, v) {
        if (!!str) {
          data[key].forEach(function (i, index, arr) {
            i.checked = false;
          });
        }
        arr.push({
          key: key,
          checked: false,
          detail: data[key],
        });
      });
      return arr;
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 去重
    // 数组对象去重
    setArr(arr, key) {
      var a = {},
        newArr = [];
      arr.forEach(function (item, i, arr) {
        a[item.id] = item.id;
      });
      for (var Vkey in a) {
        for (var index = 0; arr.length > index; index++) {
          if (a[Vkey] == arr[index].id) {
            newArr.push(arr[index]);
            break;
          }
        }
      }
      return newArr;
    },
    setDeptArr(arr, key) {
      var a = {},
        newArr = [];
      arr.forEach(function (item, i, arr) {
        a[item.pkDept] = item.pkDept;
      });
      for (var Vkey in a) {
        for (var index = 0; arr.length > index; index++) {
          if (a[Vkey] == arr[index].pkDept) {
            newArr.push(arr[index]);
            break;
          }
        }
      }
      console.log(newArr);
      return newArr;
    },
    // 文件转码
    readBlobAsDataURL(blob, callback) {
      var a = new FileReader();
      a.readAsDataURL(blob);
      a.onload = function (e) {
        callback(e.target.result);
      };
    },
    depDeptSortLLL(arr) {
      let newArr = [];
      arr.forEach(function (item, index, arr) {
        // item.childMenu=[];
        if (item.parentId == "0") {
          newArr.push(item);
          item.childMenu = a(arr, item.customerSortId);
        }
      });
      return newArr;

      function a(arr, childId) {
        var newArr1 = [];
        for (let i = 0; arr.length > i; i++) {
          if (arr[i].parentId == childId) {
            newArr1.push(arr[i]);
            arr[i].childMenu = a(arr, arr[i].customerSortId);
          }
        }
        return newArr1;
      }
    },
    // depDeptSort a方法 接口字段修改pkDept=>id 待联调
    depDeptSort(arr) {
      console.log("arr", arr);
      let newArr = [];
      arr.forEach(function (item, index, arr) {
        console.log("数组item", item);
        // item.childMenu=[];
        if (item.parentId == "0") {
          newArr.push(item);
          item.childMenu = a(arr, item.id);
        } else {
          if (!arr.some((q) => q.id == item.parentId)) {
            newArr.push(item);
            item.childMenu = a(arr, item.id);
          }
        }
      });
      // console.log(newArr)
      return newArr;

      function a(arr, childId) {
        var newArr1 = [];
        for (let i = 0; arr.length > i; i++) {
          if (arr[i].parentId == childId) {
            newArr1.push(arr[i]);
            arr[i].childMenu = a(arr, arr[i].id);
            if (arr[i].childMenu.length == 0) {
              arr[i].childMenu = null;
            }
          }
        }

        return newArr1;
      }
    },
    ifArrDisabled(arr, str) {
      arr.forEach((it) => {
        if (!!it[str].length) {
          it.disabled = true;
          this.ifArrDisabled(it[str], str);
        } else {
          it.disabled = false;
        }
      });
    },
    // 返回叶子节点
    leafNode(arr, str, newArr = []) {
      arr.forEach((it, i) => {
        if (it[str].length == 0) {
          newArr.push(it);
        } else {
          this.leafNode(it[str], str, newArr);
        }
      });
      return newArr;
    },
    // 拍平数组 多重 str为内数组
    flatChild(arr, str, newArr = []) {
      let arrSet = this.deepClone(arr);
      arr.forEach((it, i) => {
        arrSet[i][str] = [];
        newArr.push(arrSet[i]);
        if (it[str] && it[str].length != 0) {
          this.flatChild(it[str], str, newArr);
        }
      });
      return newArr;
    },
    uniqueObjArr(arr, str) {
      //对象数组去重
      let result = {};
      let finalResult = [];
      for (let i = 0; i < arr.length; i++) {
        result[arr[i][str]] = arr[i];
      }
      for (let item in result) {
        finalResult.push(result[item]);
      }
      return finalResult;
    },
    findAllFNode(arr, keyArr) {
      //返回给定的keyArr所有父节点 ，未去重
      let list = [];
      keyArr.forEach((it) => {
        if (it.parentId == 0) return; //最外面一层了
        let selectObj = arr.find((item) => {
          return it.parentId == item.id;
        });
        if (!!selectObj) {
          // console.log('selectObj',selectObj.resourcesName)
          list.push(selectObj);
          if (selectObj.parentId != 0) {
            list.push(...this.findAllFNode(arr, [selectObj]));
          }
        }
      });
      return list;
    },
    // 递归取值去重数组
    getReturnArr(arr, child, isType) {
      let type = Object.prototype.toString.call(arr);
      let arrs = [];
      if (type == "[object Array]") {
        arr.forEach((v, index, a) => {
          // arrs.push
          if (v[child] != 0) {
            arrs.push(v);
            arrs = arrs.concat(this.getReturnArr(v[child], child, isType));
          } else {
            // 没有child 证明 这个是他的根节点 可以方便遍历
            if (isType) {
              v.isType = true;
            }
            arrs.push(v);
          }
        });
      }
      return arrs;
    },
    // 单个拍平数组
    openArr(arr) {
      let result = [];
      arr.map((item) => {
        item instanceof Array
          ? (result = result.concat(this.openArr(item)))
          : result.push(item);
      });
      return result;
    },
    /**
     * @Description:  组树和排序
     */
    sortList(arr, str) {
      let _self = this;
      let newArr = [];
      arr.forEach(function (item, index, arr) {
        // item.childMenu=[];
        if (item.parentId == "0") {
          newArr.push(item);
          item.children = a(arr, item.id);
        }
      });
      if (newArr.length == 0) {
        arr.forEach(function (item, index, arr) {
          // item.childMenu=[];
          if (item.parentId == "1111111") {
            newArr.push(item);
            item.children = a(arr, item.id);
          }
        });
      }
      if (str) {
        newArr.sort(_self.sortCompare(str)); //一级排序
        sortAllS(newArr);
      }
      return newArr;
      // end
      function sortAllS(arr) {
        arr.forEach(function (item) {
          if (Array.isArray(item.childMenu)) {
            item.children.sort(_self.sortCompare(str));
            sortAllS(item.childMenu);
          }
        });
      }

      function a(arr, childId) {
        var newArr1 = [];
        arr.forEach(function (item, index, arr) {
          if (item.parentId == childId) {
            newArr1.push(item);
            item.children = a(arr, item.id);
          }
        });
        return newArr1;
        console.log(newArr1);
      }
    },
    getQuery(name) {
      var search = location.href;
      var pattern = new RegExp("[?&]" + name + "=([^&]+)", "g");
      var matcher = pattern.exec(search);
      var items = null;
      if (null != matcher) {
        try {
          items = decodeURIComponent(decodeURIComponent(matcher[1]));
        } catch (e) {
          try {
            items = decodeURIComponent(matcher[1]);
          } catch (e) {
            items = matcher[1];
          }
        }
      }
      return items;
    },
    getCartNum(cal) {
      // 不用了
      return;
      let _self = this;
      var localData = JSON.parse(window.LS.get("SY"));
      this.axios({
        method: "post",
        url:
          "/payment/" +
          (localData.corp.corpType == "0" ? "" : "order/") +
          "product/countCart",
        transformRequest: [
          function (data) {
            return qs.stringify(data);
          },
        ],
      }).then(function (res) {
        if (res.data.code == "0") {
          _self.$emit("cartNum", res.data.data);
          if (cal) cal(res.data.data);
          // _self.MixsuccessMes(res.data.message);
        } else {
        }
      });
    },
    checkPhone(value, callback) {
      var myreg = /^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$/;
      console.log(value);
      value = parseInt(value);
      if (!Number.isInteger(value)) {
        callback("输入字符不合法");
        return false;
      } else {
        if (!myreg.test(value)) {
          callback("请输入合法手机号");
          return false;
        } else {
          return true;
        }
      }
    },
    sortCompareDown(prop) {
      //按某一属性值 降序排列
      return function (obj1, obj2) {
        var val1 = obj1[prop];
        var val2 = obj2[prop];
        if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
          val1 = Number(val1);
          val2 = Number(val2);
        }
        if (val1 > val2) {
          return -1;
        } else if (val1 < val2) {
          return 1;
        } else {
          return 0;
        }
      };
    },
    sortCompare(prop) {
      //按某一属性值 升序排列
      return function (obj1, obj2) {
        var val1 = obj1[prop];
        var val2 = obj2[prop];
        if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
          val1 = Number(val1);
          val2 = Number(val2);
        }
        if (val1 < val2) {
          return -1;
        } else if (val1 > val2) {
          return 1;
        } else {
          return 0;
        }
      };
    },
    MixsuccessMes(mes) {
      this.$message({
        message: mes,
        type: "success",
      });
    },
    MixerrorMes(mes) {
      this.$message({
        message: mes,
        type: "error",
      });
    },
    MixWarnMes(mes) {
      this.$message({
        message: mes,
        type: "warning",
      });
    },
    axiosToken() {
      if (window.LS.get("token")) {
        Vue.axios.defaults.token = window.LS.get("token");
      }
    },
    getMessageNum() {
      return;
      let _self = this;
      let id = JSON.parse(window.LS.get("BB")).id;
      _self
        .axios({
          method: "post",
          url: "/agentAccount/notes/queryNotesNum",
          data: qs.stringify({
            id: id,
          }),
        })
        .then(function (res) {
          let data = res.data;
          if (data.code == "0") {
            _self.messageNum = res.data.data.unreadMessage; //所有消息
            if (sessionStorage.getItem("itemMessage") == null) {
              //null视为登录会弹窗
              sessionStorage.setItem(
                "itemMessage",
                res.data.data.TaskItemMessage || 0
              ); //新待办存取来
              // 不存在
              _self.showItemMessageNum = res.data.data.TaskItemMessage || 0; //新待办消息
              _self.showItemMessage = _self.showItemMessageNum != 0; //有新消息才弹窗
              _self.$emit("messageTask", {
                showItemMessage: _self.showItemMessage,
                showItemMessageNum: _self.showItemMessageNum,
              });
            } else {
              // 已登录
              if (sessionStorage.getItem("timeCount")) {
                //已点确定
                if (
                  new Date().getTime() >= sessionStorage.getItem("timeCount")
                ) {
                  //时间已到，弹窗
                  _self.$emit("messageTask", {
                    // 数量要一直有
                    showItemMessage: res.data.data.TaskItemMessage != 0,
                    showItemMessageNum: res.data.data.TaskItemMessage || 0, //新待办消息
                  });
                } else {
                  //时间未到
                  _self.$emit("messageTask", {
                    showItemMessage: false,
                    showItemMessageNum: res.data.data.TaskItemMessage || 0, //新待办消息
                  });
                }
              } else {
                // 未点确定
                _self.$emit("messageTask", {
                  showItemMessage: res.data.data.TaskItemMessage != 0,
                  showItemMessageNum: res.data.data.TaskItemMessage || 0, //新待办消息
                });
              }
            }
            _self.$emit("messageNum", _self.messageNum);
          }
        });
    },

    addressComponent(call) {
      // todo 改为本地文件
      this.axios({
        method: "post",
        url: "/platform/area/getAreaList",
        data: {
          id: "",
          pid: "",
          area: "",
          level: "",
        },
      }).then((res) => {
        let data = res.data;

        function deOneLine(arr, result = []) {
          for (let i in arr) {
            result.push({
              pid: arr[i].pid,
              id: arr[i].id,
              level: arr[i].level,
              area_name: arr[i].area,
              value: arr[i].area,
            });
            if (arr[i].children.length != 0) {
              deOneLine(arr[i].children, (result[i].city = []));
            }
          }
          return result;
        }

        if (data.code == "0") {
          let addressData = deOneLine(data.data[0].children);
          call ? call(addressData) : "";
        }
      });
    },
    /**
     * input转正整数
     * @param num 数字 字符串或者纯数字
     * @param type 要转的类型 默认String
     * @return integer 返回是数字
     */
    numberinteger(num, type = "string") {
      let integer = null;
      if (isNaN(num)) {
        integer = num.replace(/^(0+)|[^\d]+/g, "");
      } else {
        integer = num.toString().replace(/^(0+)|[^\d]+/g, "");
      }
      return type === "string" ? integer : integer ? parseInt(integer) : 0;
    },
    numFormat22(num) {
      if (isNaN(num)) return;
      num = (num ? num : 0).toFixed(2);
      return num.toString().replace(/\d+/, function (n) {
        // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
          return $1 + ",";
        });
      });
    },
    numFormat2(num) {
      if (isNaN(num)) return num; //哎。先留着
      if (!num) return;
      num = (num - 0).toFixed(2);
      return num.toString().replace(/\d+/, function (n) {
        // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
          return $1 + ",";
        });
      });
    },
    numFormatFixed2(num) {
      num = (num || 0).toFixed(2);
      return num.toString().replace(/\d+/, function (n) {
        // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
          return $1 + ",";
        });
      });
    },
    numFormat(num) {
      if (!num) return 0;
      return num.toString().replace(/\d+/, function (n) {
        // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
          return $1 + ",";
        });
      });
    },
    TIMECYCLE(layout, time) {
      if (time && time.length === 13) time = parseInt(time);
      let i = time ? new Date(time) : new Date();
      if (!layout) return i;
      let year = i.getFullYear();
      let month =
        i.getMonth() + 1 < 10 ? "0" + (i.getMonth() + 1) : i.getMonth() + 1;
      let date = i.getDate() < 10 ? "0" + i.getDate() : i.getDate();
      let hour = i.getHours() < 10 ? "0" + i.getHours() : i.getHours();
      let minute = i.getMinutes() < 10 ? "0" + i.getMinutes() : i.getMinutes();
      let second = i.getSeconds() < 10 ? "0" + i.getSeconds() : i.getSeconds();
      const a = {
        "yyyymmdd hh:mm:ss": () => {
          return `${year}${month}${date} ${hour}:${minute}:${second}`;
        },
        "yyyy-mm-dd hh:mm:ss": () => {
          return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
        },
        "yyyy-mm-dd": () => {
          return `${year}-${month}-${date}`;
        },
        "hh:mm:ss": () => {
          return `${hour}:${minute}:${second}`;
        },
        "yyyy-mm": () => {
          return `${year}-${month}`;
        },
        "mm-dd": () => {
          return `${month}-${date}`;
        },
        yyyy: () => {
          return `${year}`;
        },
        mm: () => {
          return `${month}`;
        },
        dd: () => {
          return `${date}`;
        },
      };
      return a[layout]();
    },
    formPdf(call) {
      this.axios
        .post({
          method: "get",
          url: "/agentAccount/bill/delete",
          params: {
            id: file.id,
            pkAccountBook: this.accountBook.pkAccountBook,
          },
        })
        .then((res) => {
          if (res.data.code == "0") {
            that.$message.success("删除成功");
            that.deleteFile(file.pkFileInfoId);
            that.updateAllSuccess();
          } else {
            this.MixerrorMes(res.data.message);
          }
        });
    },
    changecarousel(index, preIndex) {
      this.formDataShow(this.enlargeImageData[index]);
    },
    formDataShowNew(obj) {
      this.VATWords = {};
      this.axios
        .get("/bill/result/findByBillId", {
          params: obj,
        })
        .then((res) => {
          if (res.data.code == "0") {
            res.data.data = res.data.data || {}; //有时会给你null
            // 后面硬要加billFirstType这些字段，修改type的编辑值 weak
            res.data.data.oldTypeShouldSeve = res.data.data.type;
            res.data.data.type = res.data.data.billFirstType || 1;
            this.VATWords = res.data.data;
            console.log(this.VATWords);
          } else {
            this.MixerrorMes(res.data.message);
          }
        })
        .finally(() => {
          this.loadingMin = false;
        });
    },
    /**
     * @description: 判断0 null undefined  返回值金额
     * @param {*}
     * @return {*}
     */
    NumNullConfirmBackMoney(str, bacTr) {
      if (str === undefined || str === null) {
        return bacTr;
      }
      return this.numFormat22(str - 0);
    },
    /**
     * @description: 判断0 null undefined  返回值
     * @param {*}
     * @return {*}
     */
    NumNullConfirm(str, bacTr) {
      if (str === undefined || str === null) {
        return bacTr;
      }
      return str;
    },
    /**
     * @description: 节流函数
     * @param {*fn执行函数  ，delay延时时间 }
     * @return {*}
     */
    debounce(fn, delay) {
      return () => {
        if (this.timerDebounce) {
          clearTimeout(this.timerDebounce);
          this.timerDebounce = setTimeout(fn, delay);
        } else {
          this.timerDebounce = setTimeout(fn, delay);
        }
      };
    },
    formDataShow(obj) {
      this.VATWords = {};
      this.axios
        .post("/agentAccount/recognition/findVATWords", obj)
        .then((res) => {
          if (res.data.code == "0") {
            this.VATWords = res.data.data;
          } else {
            this.MixerrorMes(res.data.message);
          }
        })
        .finally(() => {
          this.loadingMin = false;
        });
    },
    /**
     * @description: 5.7需求 去重children等[]的时候赋值为null 满足element的需求
     * @param {*}
     * @return {*}
     */
    setChlidrenArr(arr = [], chliren) {
      arr.forEach((q) => {
        // q[chliren]
        if (!q[chliren] || q[chliren].length == 0) {
          q[chliren] = null;
        } else {
          q[chliren] = this.setChlidrenArr(q[chliren], chliren);
        }
      });
      return arr;
    },

    /**
     * @description: 设置皮肤
     * @param {themeName} 自定义的样式名称
     * @return {*}
     */

    setStyleRoot(themeName, themeList = []) {
      let arr = themeList.filter((q) => q.themeName == themeName);
      if (arr.length == 0) return console.error("未设置样式皮肤");
      let item = arr[0];
      let root = [];
      for (let i in item.style) {
        root.push(i + `:` + item.style[i]);
      }
      let test = `:root{${root.join(";")}}`;
      this.addNode(test, item.src);
    },

    /**
     * @description: 6.4需求 添加节点皮肤节点
     * @param {test} 设置:root 样式
     * @param {url} 插入的外链
     * @return {*}
     */
    addNode(test, url) {
      let styleNode = document.getElementById("theme");
      let linkNode = document.getElementById("linkTheme");
      if (styleNode) {
        styleNode.innerHTML = test;
        document.getElementsByTagName("body")[0].appendChild(styleNode);
        if (linkNode.getAttribute("href") != url) {
          linkNode.setAttribute("href", url);
        }
      } else {
        styleNode = document.createElement("style");
        linkNode = document.createElement("link");
        styleNode.setAttribute("id", "theme");
        linkNode.setAttribute("href", url);
        linkNode.setAttribute("id", "linkTheme");
        linkNode.setAttribute("rel", "stylesheet");
        linkNode.setAttribute("type", "text/css");
        styleNode.innerHTML = test;
        document.getElementsByTagName("body")[0].appendChild(styleNode);
        document.getElementsByTagName("head")[0].appendChild(linkNode);
      }
    },

    /**
     * base64  to blob二进制
     */
    dataURItoBlob(dataURI) {
      var byteString = atob(dataURI.split(",")[0]); //base64 解码
      var arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组
      var intArray = new Uint8Array(arrayBuffer); //创建视图
      for (var i = 0; i < byteString.length; i++) {
        intArray[i] = byteString.charCodeAt(i);
      }
      // return new Blob([intArray],{type: "application/vnd.ms-excel;charset=utf-8;"});//原来封装好的 下载的是excel
      return new Blob([intArray], {
        type: "application/octet-stream;charset=utf-8;",
      }); //修改-1
    },
  },
  mounted() {},
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      if (to.path == "/workSpace" && vm.userInfo.pkUser) {
        //一直访问也有点烦
        vm.getMessageNum();
      }
    });
  },
  created() {
    if (window.LS.get("Auth")) {
      this.AuthArr = JSON.parse(window.LS.get("Auth"));
    }
    if (window.LS.get("SY")) {
      this.userInfo = JSON.parse(window.LS.get("SY")).userInfo;
      console.log("this.userInfo", this.userInfo);
      this.userCorp = JSON.parse(window.LS.get("SY")).corp || {};
      if (
        Vue.axios.defaults.headers.common.pkManagerCorp !=
        this.userCorp.pkManagerCorp
      ) {
        this.axiosToken();
      }
    }
    if (!Vue.axios.defaults.token) {
      this.axiosToken();
    }
  },
};
